import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "../../styles/website/Home.css";
import "../../styles/website/FittingRoom.css";
import Layout from "../website/component/Layout.jsx";

// ⚠️ مسیر این دو فایل API را مطابق پروژه‌ات درست کن (همان‌هایی که قبلاً VirtualTryOn استفاده می‌کرد)
import { runWebsiteTryOn } from "../../api/tryOn.js";

import { sendProMajaziOtp, verifyProMajaziOtp } from "../../api/proMajazi.js";
/* =====================================================
   تنظیمات — فقط همین بخش را ویرایش کن
   ===================================================== */
const CONFIG = {
  brandName: "میکســـو | MIXO",
  storeId: 83, // شناسهٔ فروشگاه برای پرو آنلاین
};

// فقط همین لباس‌ها نمایش داده می‌شود.
// عکس‌ها داخل src/assets/fittingroom با نام a1 (جلو)، a2 (سه‌رخ)، a3 (پشت)
// تا l1 و l2 و l3 قرار می‌گیرند (پسوند مهم نیست: png / jpg / webp)
const DEMO_NAMES = [
  "تیشرت مردانه باکسی پرسیسکا",
  "کت تک مردانه سورمه ای",
  "تی شرت لانگ زنانه نخی",
  "ژاکت زنانه طرح حیوانات یقه هفت",
  "سویشرت زنانه پنبه‌ای",
  "پلیور زنانه مدل راه‌راه",
  "پیراهن کبریتی",
  "لباس بلند سبز پسته ای",
  "سوئیشرت یقه هفت قهوه ای",
  "تیشرت مردانه باکسی پرسیسکا",
  "کراپ هودی زنانه",
  "ژیله زنانه مدل پاپیون",
];

const IMAGE_LETTERS = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
];
const RACK_SCALE = [
  1, 0.98, 1.02, 0.99, 1.01, 0.97, 1.02, 1, 0.99, 1.01, 0.98, 1.02, 1, 0.99,
];
const RACK_TURN = [
  -46, -42, -50, -44, -48, -40, -51, -45, -47, -43, -49, -41, -50, -44,
];

// عرض دستیِ چوب‌لباسی برای یک لباس خاص (اختیاری)
// کلید = اندیس لباس (از صفر)، مقدار = عرض چوب‌لباسی نسبت به عرض لباس (بین ۰.۳ تا ۰.۷۲)
// مثال: { 3: 0.5 }  → چوب‌لباسی لباس چهارم باریک‌تر می‌شود
// اگر لباسی اینجا نباشد، عرض چوب‌لباسی خودکار از روی شانه‌ی لباس تنظیم می‌شود
const HANGER_OVERRIDE = {};

// فاصله بین گروه‌ها: اندیس لباس‌هایی (از صفر) که یک گروه جدید با آن‌ها شروع می‌شود
const GAP_BEFORE = [3, 6];

// اندازه‌ی واقعی لباس‌ها نسبت به هم (مثلاً سرهمی بزرگ‌تر از تی‌شرت دیده شود)
// عرض شانه‌ی (بالاتنه‌ی) همه‌ی لباس‌ها یکسان می‌شود؛ بنابراین لباس بلندتر (مثل سرهمی) بلندتر دیده می‌شود
// و آستین یا پای بازِ لباس باعث کوچک شدنش نمی‌شود.
// اگر نخواستی AUTO_SIZE را false کن و اندازه را دستی با SIZE_OVERRIDE بده.
const AUTO_SIZE = true;
const SHOULDER_DEPTH = 0.2; // خط شانه چقدر زیر بالای لباس است (نسبت به عرض لباس)
const SHOULDER_REF = 0.9; // عرض شانه (نسبت به عرض عکس) که اندازه‌ی «عادی» حساب می‌شود
// ضریب دستی اندازه برای هر لباس (کلید = اندیس از صفر). مثال: { 4: 1.3 } لباس پنجم ۳۰٪ بزرگ‌تر
const SIZE_OVERRIDE = {};

const fittingRoomImages = import.meta.glob("../../assets/fittingroom/*", {
  eager: true,
  import: "default",
  query: "?url",
});

// پیدا کردن عکس با نام فایل (بدون توجه به پسوند و حروف بزرگ/کوچک)
const findImage = (baseName) => {
  const target = baseName.toLowerCase();
  const entry = Object.entries(fittingRoomImages).find(([path]) => {
    const fileName = path.split("/").pop().toLowerCase();
    return fileName.replace(/\.[^.]+$/, "") === target;
  });
  return entry?.[1] || "";
};

const hangerImage = findImage("hanger");
const sceneImage = findImage("rack-bg"); // عکس پس‌زمینه‌ی رگال (دسکتاپ)
const mobileSceneImage = findImage("rack-bg-mobile"); // پس‌زمینه‌ی موبایل

const ITEMS = DEMO_NAMES.map((name, i) => {
  const letter = IMAGE_LETTERS[i];
  return {
    id: i + 1, // اگر بک‌اند id واقعی محصول می‌خواهد، اینجا جایگزین کن
    name,
    front: findImage(`${letter}1`),
    side: findImage(`${letter}2`),
    back: findImage(`${letter}3`),
    hw: HANGER_OVERRIDE[i],
    gap: GAP_BEFORE.includes(i),
  };
});

// جا دادن همه‌ی لباس‌ها بین دو پایه‌ی رگال (واحدها همان px طراحی‌اند)
const HANG_AVAIL = 867; // عرض فضای بین دو پایه
const ITEM_W = 240;
const GAP_W = 120; // فاصله‌ی بین گروه‌ها
const gapCount = ITEMS.filter((it) => it.gap).length;
const STEP = Math.min(
  60,
  Math.max(
    24,
    (HANG_AVAIL - ITEM_W - gapCount * GAP_W) / Math.max(1, ITEMS.length - 1),
  ),
);

/* ===================================================== */

const fa = (n) => Number(n).toLocaleString("fa-IR");

// وقتی پنجره‌ی پرو آنلاین باز است، کلیدهای مودال اتاق پرو نباید کار کنند
const tryOnIsOpen = () => !!document.querySelector(".vto-overlay");

/* =====================================================
   حذف پس‌زمینه‌ی سفید عکس (در خود مرورگر)
   از لبه‌ها شروع می‌کند و فقط پس‌زمینه‌ی متصل به لبه را شفاف می‌کند،
   پس رنگ‌های روشنِ داخل لباس (مثل برچسب) سالم می‌مانند.
   ===================================================== */
const cutCache = new Map();
function cutout(src) {
  if (cutCache.has(src)) return cutCache.get(src);
  const p = new Promise((resolve, reject) => {
    const im = new Image();
    im.onerror = () => reject("missing");
    im.onload = () => {
      try {
        const w = im.naturalWidth,
          h = im.naturalHeight;
        const c = document.createElement("canvas");
        c.width = w;
        c.height = h;
        const ctx = c.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(im, 0, 0);
        const d = ctx.getImageData(0, 0, w, h),
          px = d.data;
        const T = 236,
          N = w * h;
        const mask = new Uint8Array(N),
          stack = [];
        const bg = (k) => {
          const i = k * 4;
          return px[i] > T && px[i + 1] > T && px[i + 2] > T;
        };
        const push = (k) => {
          if (!mask[k] && bg(k)) {
            mask[k] = 1;
            stack.push(k);
          }
        };
        for (let x = 0; x < w; x++) {
          push(x);
          push((h - 1) * w + x);
        }
        for (let y = 0; y < h; y++) {
          push(y * w);
          push(y * w + w - 1);
        }
        while (stack.length) {
          const k = stack.pop(),
            x = k % w,
            y = (k / w) | 0;
          if (x > 0) push(k - 1);
          if (x < w - 1) push(k + 1);
          if (y > 0) push(k - w);
          if (y < h - 1) push(k + w);
        }
        let cnt = 0;
        for (let k = 0; k < N; k++) cnt += mask[k];
        if (cnt < N * 0.02 || cnt > N * 0.92) {
          resolve({ url: src, cut: false });
          return;
        } // لباس سفید یا پس‌زمینه‌ی غیرسفید
        // لبه‌ی نرم: پیکسل‌های مجاور پس‌زمینه
        const ring = [];
        for (let k = 0; k < N; k++) {
          if (mask[k]) continue;
          const x = k % w,
            y = (k / w) | 0;
          if (
            (x > 0 && mask[k - 1]) ||
            (x < w - 1 && mask[k + 1]) ||
            (y > 0 && mask[k - w]) ||
            (y < h - 1 && mask[k + w])
          )
            ring.push(k);
        }
        for (let k = 0; k < N; k++) if (mask[k]) px[k * 4 + 3] = 0;
        for (const k of ring) {
          const i = k * 4,
            m = Math.min(px[i], px[i + 1], px[i + 2]);
          let a = (255 - m) / (255 - 40);
          a = Math.max(0.15, Math.min(1, a));
          if (a < 1) {
            for (let j = 0; j < 3; j++) {
              px[i + j] = Math.max(
                0,
                Math.min(255, (px[i + j] - 255 * (1 - a)) / a),
              );
            }
            px[i + 3] = Math.round(a * 255);
          }
        }
        ctx.putImageData(d, 0, 0);
        // برش حاشیه‌ی خالی دور لباس
        let x0 = w,
          y0 = h,
          x1 = 0,
          y1 = 0;
        for (let k = 0; k < N; k++) {
          if (mask[k]) continue;
          const x = k % w,
            y = (k / w) | 0;
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        }
        const pad = Math.round(Math.max(w, h) * 0.012);
        x0 = Math.max(0, x0 - pad);
        y0 = Math.max(0, y0 - pad);
        x1 = Math.min(w - 1, x1 + pad);
        y1 = Math.min(h - 1, y1 + pad);
        const tw = x1 - x0 + 1,
          th = y1 - y0 + 1;
        const t = document.createElement("canvas");
        t.width = tw;
        t.height = th;
        t.getContext("2d").drawImage(c, x0, y0, tw, th, 0, 0, tw, th);

        // پروفایل عرض لباس در نیمه‌ی بالایی (برای تنظیم خودکار چوب‌لباسی)
        // prof[i] = عرض لباس (نسبت به عرض عکس) در عمق i/(N-1) * ۰.۵ ارتفاع
        const N_PROF = 80;
        const prof = new Float32Array(N_PROF);
        for (let i = 0; i < N_PROF; i++) {
          const sy = Math.min(
            h - 1,
            y0 + Math.round((i / (N_PROF - 1)) * 0.5 * th),
          );
          let l = -1,
            r = -1;
          for (let x = x0; x <= x1; x++) {
            if (!mask[sy * w + x]) {
              l = x;
              break;
            }
          }
          for (let x = x1; x >= x0; x--) {
            if (!mask[sy * w + x]) {
              r = x;
              break;
            }
          }
          prof[i] = l < 0 ? 0 : (r - l + 1) / tw;
        }

        resolve({
          url: t.toDataURL("image/png"),
          cut: true,
          ratio: tw / th,
          canvas: t,
          prof,
        });
      } catch (e) {
        resolve({ url: src, cut: false });
      } // مثلاً باز کردن مستقیم فایل از روی دیسک
    };
    im.src = src;
  });
  cutCache.set(src, p);
  return p;
}

/* سایه‌روشن پارچه: لبه‌ها تیره‌تر، وسط روشن‌تر، چین‌های ملایم و تیرگی پایین‌دامن
   (فقط روی رگال؛ عکس نمای بزرگ دست‌نخورده می‌ماند) */
function shadeCanvas(src, turn) {
  const W = src.width,
    H = src.height;
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const x = c.getContext("2d");
  x.drawImage(src, 0, 0);
  x.globalCompositeOperation = "source-atop";
  let g = x.createLinearGradient(0, 0, W, 0);
  const dk = 0.46,
    lt = 0.1,
    d = (turn || 0) < 0 ? -1 : 1;
  g.addColorStop(0, `rgba(0,0,0,${d > 0 ? dk : lt})`);
  g.addColorStop(0.25, `rgba(0,0,0,${d > 0 ? 0.16 : 0.04})`);
  g.addColorStop(0.55, "rgba(255,255,255,.07)");
  g.addColorStop(0.8, `rgba(0,0,0,${d > 0 ? 0.04 : 0.16})`);
  g.addColorStop(1, `rgba(0,0,0,${d > 0 ? lt : dk})`);
  x.fillStyle = g;
  x.fillRect(0, 0, W, H);
  g = x.createLinearGradient(0, H * 0.5, 0, H);
  g.addColorStop(0, "rgba(0,0,0,0)");
  g.addColorStop(1, "rgba(0,0,0,.2)");
  x.fillStyle = g;
  x.fillRect(0, 0, W, H);
  g = x.createLinearGradient(0, 0, 0, H * 0.22);
  g.addColorStop(0, "rgba(255,255,255,.10)");
  g.addColorStop(1, "rgba(255,255,255,0)");
  x.fillStyle = g;
  x.fillRect(0, 0, W, H);
  // چین‌های عمودیِ ملایم
  const f = document.createElement("canvas");
  f.width = W;
  f.height = H;
  const fx = f.getContext("2d");
  [
    [0.27, 0.07, -1],
    [0.4, 0.06, 1],
    [0.55, 0.07, -1],
    [0.68, 0.06, 1],
    [0.78, 0.05, -1],
  ].forEach(([cx, fw, sgn]) => {
    fx.save();
    fx.setTransform(1, 0, sgn * 0.08, 1, -sgn * 0.08 * H * 0.5, 0);
    const gx = fx.createLinearGradient((cx - fw) * W, 0, (cx + fw) * W, 0);
    const col = sgn < 0 ? "0,0,0" : "255,255,255",
      al = sgn < 0 ? 0.12 : 0.08;
    gx.addColorStop(0, `rgba(${col},0)`);
    gx.addColorStop(0.5, `rgba(${col},${al})`);
    gx.addColorStop(1, `rgba(${col},0)`);
    fx.fillStyle = gx;
    fx.fillRect((cx - fw) * W - W * 0.2, 0, fw * 2 * W + W * 0.4, H);
    fx.restore();
  });
  fx.globalCompositeOperation = "destination-in";
  const fm = fx.createLinearGradient(0, 0, 0, H);
  fm.addColorStop(0, "rgba(0,0,0,0)");
  fm.addColorStop(0.28, "rgba(0,0,0,0)");
  fm.addColorStop(0.5, "rgba(0,0,0,1)");
  fm.addColorStop(0.85, "rgba(0,0,0,.7)");
  fm.addColorStop(1, "rgba(0,0,0,0)");
  fx.fillStyle = fm;
  fx.fillRect(0, 0, W, H);
  x.drawImage(f, 0, 0);
  return c.toDataURL("image/png");
}

/* جای خالی وقتی عکس پیدا نشد */
function placeholder() {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
  <path d="M150 70 L70 105 L40 180 L95 205 L110 180 L110 340 L290 340 L290 180 L305 205 L360 180 L330 105 L250 70 C240 100 160 100 150 70Z"
   fill="none" stroke="#b9b2a6" stroke-width="2" stroke-dasharray="6 6" stroke-linejoin="round"/></svg>`;
  return "data:image/svg+xml;utf8," + encodeURIComponent(svg);
}

/* عکس را بارگذاری و برش می‌دهد.
   src === null  → منتظر می‌ماند
   src === ""    → عکس پیدا نشده، جای خالی نشان می‌دهد */
function useProcessedImage(src, shade = false, turn = 0) {
  const [st, setSt] = useState({
    url: "",
    status: "loading",
    cut: false,
    ratio: null,
    prof: null,
    ready: false,
  });

  useEffect(() => {
    if (src == null) {
      setSt({
        url: "",
        status: "loading",
        cut: false,
        ratio: null,
        prof: null,
        ready: false,
      });
      return;
    }
    let dead = false,
      raf;
    const markReady = () => {
      raf = requestAnimationFrame(() => {
        if (!dead) setSt((s) => ({ ...s, ready: true }));
      });
    };
    const showMissing = () => {
      setSt({
        url: placeholder(),
        status: "missing",
        cut: false,
        ratio: null,
        prof: null,
        ready: false,
      });
      markReady();
    };

    if (src === "") {
      showMissing();
      return () => {
        dead = true;
        cancelAnimationFrame(raf);
      };
    }

    setSt({
      url: "",
      status: "loading",
      cut: false,
      ratio: null,
      prof: null,
      ready: false,
    });
    cutout(src)
      .then((r) => {
        if (dead) return;
        const url = shade && r.canvas ? shadeCanvas(r.canvas, turn) : r.url;
        setSt({
          url,
          status: "ok",
          cut: !!r.cut,
          ratio: r.ratio || null,
          prof: r.prof || null,
          ready: false,
        });
        markReady();
      })
      .catch(() => {
        if (!dead) showMissing();
      });
    return () => {
      dead = true;
      cancelAnimationFrame(raf);
    };
  }, [src, shade, turn]);

  return st;
}

const imgClass = (st) =>
  [
    st.ready ? "is-ready" : "",
    st.status === "ok" && !st.cut ? "is-nocut" : "",
    st.status === "missing" ? "is-ph" : "",
  ]
    .filter(Boolean)
    .join(" ");

/* =====================================================
   تنظیم خودکار عرض چوب‌لباسی
   عرض چوب‌لباسی (نسبت به عرض لباس) طوری انتخاب می‌شود که
   انتهای دو بازوی چوب‌لباسی داخل شانه‌ی لباس بنشیند و بیرون نزند.
   برای تی‌شرت همان ۰.۷۲ قبلی می‌ماند.
   ===================================================== */
const HANGER_MAX = 0.72;
const HANGER_MIN = 0.3;
const HANGER_SINK = 0.3; // چوب‌لباسی چند درصدِ ارتفاع خودش داخل لباس فرو می‌رود (با CSS یکی است)

function fitHanger(prof, ratio, hr) {
  if (!prof || !ratio) return HANGER_MAX;
  const N = prof.length;
  const widthAt = (d) => {
    const t = Math.min(Math.max(d / 0.5, 0), 1) * (N - 1);
    const i = Math.floor(t),
      f = t - i;
    return prof[i] * (1 - f) + prof[Math.min(i + 1, N - 1)] * f;
  };
  for (let hw = HANGER_MAX; hw >= HANGER_MIN; hw -= 0.02) {
    // عمقی از لباس (نسبت به ارتفاع لباس) که انتهای چوب‌لباسی تا آنجا می‌رسد
    const depth = HANGER_SINK * hw * hr * ratio;
    if (widthAt(depth) >= hw * 0.97) return hw;
  }
  return HANGER_MIN;
}

// عرض شانه‌ی لباس نسبت به عرض عکس
function upperWidth(prof, ratio) {
  if (!prof || !ratio) return null;
  const N = prof.length;
  const d = Math.min(0.5, SHOULDER_DEPTH * ratio); // عمق خط شانه نسبت به ارتفاع لباس
  const t = (d / 0.5) * (N - 1);
  const i = Math.floor(t),
    f = t - i;
  return prof[i] * (1 - f) + prof[Math.min(i + 1, N - 1)] * f;
}

/* ---------- Rack item ----------
   state (فقط موبایل): "active" = لباسِ وسط صفحه | "before" / "after" = بقیه */
function RackItem({ item, index, onOpen, state, hr }) {
  const turn = RACK_TURN[index % RACK_TURN.length];
  const side = useProcessedImage(item.side);
  const sideDone = side.status !== "loading";
  const realSide = side.status === "ok";
  const front = useProcessedImage(
    sideDone ? item.front : null,
    sideDone && !realSide,
    turn,
  );

  const ratio = front.ratio || side.ratio || 1;

  // عرض چوب‌لباسی: اگر دستی داده نشده، از روی شانه‌ی لباس حساب می‌شود
  const shape = front.prof ? front : side;
  // عرض شانه (نسبت به عرض عکس): اندازه‌ی لباس طوری تنظیم می‌شود که شانه‌ی همه یک‌اندازه شود
  const upper = upperWidth(shape.prof, shape.ratio);
  const upperSafe = upper ? Math.max(0.3, upper) : null;
  const auto =
    AUTO_SIZE && upperSafe
      ? Math.min(1.6, Math.max(0.7, SHOULDER_REF / upperSafe))
      : 1;
  // چوب‌لباسی از ۸۰٪ عرض شانه بزرگ‌تر نشود و داخل لباس هم بنشیند
  const hwFit = fitHanger(shape.prof, shape.ratio, hr);
  const hw =
    item.hw ??
    (upperSafe
      ? Math.max(HANGER_MIN, Math.min(hwFit, upperSafe * 0.8))
      : hwFit);
  const size =
    (item.s || RACK_SCALE[index % RACK_SCALE.length]) *
    auto *
    (SIZE_OVERRIDE[index] ?? 1);

  return (
    <button
      type="button"
      className={
        "fr-item" + (item.gap ? " fr-gap" : "") + (state ? " is-" + state : "")
      }
      style={{ "--s": size, "--hw": hw }}
      onClick={(e) => {
        // موبایل: لباس غیرِوسط اول می‌آید وسط، تپ بعدی مودال را باز می‌کند
        if (state && state !== "active") {
          e.currentTarget.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        } else {
          onOpen(index);
        }
      }}
    >
      <div
        className={"fr-swing" + (front.cut ? " is-cut" : "")}
        style={{ "--d": -((index * 1.7) % 7) + "s" }}
      >
        {hangerImage && (
          <img
            className="fr-hanger"
            src={hangerImage}
            alt=""
            draggable={false}
          />
        )}
        <div
          className={"fr-garment" + (sideDone && !realSide ? " is-fake" : "")}
          style={{ "--ar": ratio, "--ry": turn + "deg" }}
        >
          <div className="fr-lay fr-lay-s">
            <img
              className={imgClass(side)}
              src={side.url || undefined}
              alt={item.name}
              draggable={false}
            />
          </div>
          <div className="fr-lay fr-lay-f">
            <img
              className={imgClass(front)}
              src={front.url || undefined}
              alt={item.name}
              draggable={false}
            />
          </div>
        </div>
      </div>
      <div className="fr-caption">
        <div className="fr-caption-name">{item.name}</div>
      </div>
    </button>
  );
}

/* ---------- Modal ---------- */
function Modal({ items, cur, open, dir, onClose, onGo, onTryOn }) {
  const item = items[cur];
  const [flipped, setFlipped] = useState(false);
  const touch = useRef({ x: null, y: null });

  const front = useProcessedImage(item ? item.front : null);
  const back = useProcessedImage(item ? item.back : null);
  const hasBack = back.status === "ok";

  useEffect(() => {
    setFlipped(false);
  }, [cur, open]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (tryOnIsOpen()) return; // پنجره‌ی پرو آنلاین باز است
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onGo(-1);
      if (e.key === "ArrowLeft") onGo(1);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose, onGo]);

  const toggleFlip = () => {
    if (hasBack) setFlipped((f) => !f);
  };

  const onTouchStart = (e) => {
    touch.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  };
  const onTouchEnd = (e) => {
    const { x, y } = touch.current;
    if (x === null) return;
    const dx = e.changedTouches[0].clientX - x,
      dy = e.changedTouches[0].clientY - y;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      onGo(dx > 0 ? -1 : 1);
      e.preventDefault();
    }
    touch.current = { x: null, y: null };
  };

  const multi = items.length > 1;

  // مودال روی body رندر می‌شود تا هدر و فوتر سایت روی آن نیفتند
  return createPortal(
    <div
      className={"fr-modal" + (open ? " is-open" : "")}
      dir="rtl"
      aria-hidden={!open}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <button className="fr-close" aria-label="بستن" onClick={onClose}>
        <svg viewBox="0 0 24 24">
          <path d="M6 6l12 12M18 6L6 18" />
        </svg>
      </button>
      <div className="fr-counter">
        {item ? fa(cur + 1) + " / " + fa(items.length) : ""}
      </div>
      <div className="fr-sheet" role="dialog" aria-modal="true">
        <div className="fr-stage-col">
          <button
            className="fr-arrow fr-prev"
            aria-label="قبلی"
            style={multi ? undefined : { display: "none" }}
            onClick={() => onGo(-1)}
          >
            <svg viewBox="0 0 24 24">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>
          <div
            key={cur}
            className={"fr-stage" + (dir ? " fr-swap" : "")}
            style={{ "--dx": dir * 28 + "px" }}
            onClick={toggleFlip}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            <div className={"fr-card3d" + (flipped ? " is-flipped" : "")}>
              <div
                className={"fr-face fr-front" + (front.cut ? " is-cut" : "")}
              >
                <img
                  className={imgClass(front)}
                  src={front.url || undefined}
                  alt={item ? item.name + " - جلو" : ""}
                />
              </div>
              <div className={"fr-face fr-back" + (back.cut ? " is-cut" : "")}>
                <img
                  className={imgClass(back)}
                  src={back.url || undefined}
                  alt={item ? item.name + " - پشت" : ""}
                />
              </div>
            </div>
          </div>
          <button
            className="fr-arrow fr-next"
            aria-label="بعدی"
            style={multi ? undefined : { display: "none" }}
            onClick={() => onGo(1)}
          >
            <svg viewBox="0 0 24 24">
              <path d="M15 5l-7 7 7 7" />
            </svg>
          </button>
          <div className="fr-flipbar">
            <button className="fr-flip" hidden={!hasBack} onClick={toggleFlip}>
              <svg viewBox="0 0 24 24">
                <path d="M3 12a9 9 0 0 1 15.5-6.2L21 8M21 3v5h-5M21 12a9 9 0 0 1-15.5 6.2L3 16M3 21v-5h5" />
              </svg>
              <span>{flipped ? "دیدن جلوی لباس" : "دیدن پشت لباس"}</span>
            </button>
          </div>
        </div>
        <div className="fr-info">
          <h2>{item ? item.name : ""}</h2>
          <button className="fr-order" onClick={onTryOn}>
            پرو آنلاین
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

/* =====================================================
   دکور روی طبقه‌ی سفید (کفش و کیف)
   عکس‌ها را (ترجیحاً PNG با پس‌زمینه‌ی شفاف) داخل
   src/assets/fittingroom بگذار و فقط اسم فایل را اینجا بنویس
   (بدون پسوند؛ مثلاً shoe1 یعنی shoe1.png یا shoe1.webp).
   اگر عکس پیدا نشود، آن آیتم نمایش داده نمی‌شود.
   - name : اسم فایل عکس (بدون پسوند)
   - x    : جای افقی روی طبقه (درصدِ عرض رگال)
   - w    : عرض عکس به پیکسل
   اگر خواستی مستقیم URL بدهی، به جای findImage("...") بنویس:
   src: "https://example.com/shoe.png"
   ===================================================== */
/* هر آیتم این گزینه‌ها را می‌تواند داشته باشد (همه اختیاری‌اند):
   src       : عکس
   x         : جای افقی روی طبقه (درصد عرض رگال)
   y         : جابه‌جایی عمودی به پیکسل (مثبت = پایین‌تر، منفی = بالاتر)
   w         : عرض به پیکسل
   r         : چرخش به درجه (مثلاً -10 یا 6)
   flip      : true = آینه‌ی افقی
   z         : لایه (عدد بزرگ‌تر = جلوتر)
   className : کلاس دلخواه برای استایل CSS مخصوص همین آیتم
   style     : هر استایل دلخواه دیگر، مثلاً { filter: "saturate(1.2)" } */
const DECOR = [
  {
    src: findImage("decor100"),
    x: "14%",
    y: "-10",
    w: 200,
    r: 0,
    className: "fr-deco--shoe1",
  },
  {
    src: findImage("decor55"),
    x: "26%",
    w: 130,
    y: 6,
    r: -2,
    flip: false,
    className: "fr-deco--bag1",
  },
  { src: findImage("d"), x: "-50px", y: "90", w: 300, r: 0, z: 3 },
  { src: findImage("decor122"), x: "68%", w: 90, y: 70, r: 1 },
  { src: findImage("decor66"), x: "85%", y: "5", w: 160, r: 0, flip: true },
];

/* =====================================================
   پرو آنلاین: اطلاعات ← کد تایید ← عکس ← نتیجه
   همه‌ی کد و استایل همین بخش داخل همین فایل است.
   ===================================================== */
const MAX_SIDE = 1280;
const MAX_FILE_MB = 10;
const PHONE_RE = /^09\d{9}$/;
const OTP_LENGTH = 6; // اگر پیامک ۵ رقمی می‌فرستی عوضش کن
const RESEND_SECONDS = 60;
const LOADING_MESSAGES = [
  "در حال آماده‌سازی عکس شما…",
  "در حال تطبیق لباس با عکس شما…",
  "در حال ساخت تصویر نهایی…",
  "چند لحظهٔ دیگر…",
];

function Ico({ size = 20, children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}
const IcSparkle = (p) => (
  <Ico {...p}>
    <path d="M11 3l1.9 5.1L18 10l-5.1 1.9L11 17l-1.9-5.1L4 10l5.1-1.9L11 3z" />
    <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z" />
  </Ico>
);
const IcCamera = (p) => (
  <Ico {...p}>
    <path d="M4 8h3l1.5-2h7L17 8h3v11H4V8z" />
    <circle cx="12" cy="13" r="3.5" />
  </Ico>
);
const IcUpload = (p) => (
  <Ico {...p}>
    <path d="M12 16V5M7.5 9.5L12 5l4.5 4.5M5 19h14" />
  </Ico>
);
const IcClose = (p) => (
  <Ico {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Ico>
);
const IcDownload = (p) => (
  <Ico {...p}>
    <path d="M12 4v11M7.5 10.5L12 15l4.5-4.5M5 19h14" />
  </Ico>
);
const IcRefresh = (p) => (
  <Ico {...p}>
    <path d="M20 11a8 8 0 10-2.3 5.7M20 5v6h-6" />
  </Ico>
);
const IcFlip = (p) => (
  <Ico {...p}>
    <path d="M4 8h3l1.5-2h7L17 8h3v11H4V8z" />
    <path d="M9.5 13a2.5 2.5 0 014.2-1.8M14.5 13a2.5 2.5 0 01-4.2 1.8" />
    <path d="M13.8 9.8v1.6h-1.6M10.2 16.2v-1.6h1.6" />
  </Ico>
);
const IcFlash = (p) => (
  <Ico {...p}>
    <path d="M13 3L5 13.5h6L10 21l8-10.5h-6L13 3z" />
  </Ico>
);
const IcTimer = (p) => (
  <Ico {...p}>
    <circle cx="12" cy="13.5" r="7" />
    <path d="M12 10v3.8l2.4 1.4M9.5 3h5" />
  </Ico>
);
const IcGrid = (p) => (
  <Ico {...p}>
    <rect x="4" y="4" width="16" height="16" rx="1.5" />
    <path d="M9.4 4v16M14.6 4v16M4 9.4h16M4 14.6h16" />
  </Ico>
);

// تبدیل ارقام فارسی و عربی به انگلیسی
function normalizeDigits(str = "") {
  return str
    .replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)));
}

function canvasToJpeg(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("canvas"))),
      "image/jpeg",
      0.9,
    );
  });
}

function drawScaled(source, width, height, mirror = false) {
  const scale = Math.min(1, MAX_SIDE / Math.max(width, height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  const ctx = canvas.getContext("2d");
  if (mirror) {
    ctx.translate(canvas.width, 0);
    ctx.scale(-1, 1);
  }
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
  return canvas;
}

async function fileToJpegBlob(file) {
  const bmp = await createImageBitmap(file);
  const canvas = drawScaled(bmp, bmp.width, bmp.height);
  bmp.close?.();
  return canvasToJpeg(canvas);
}

function dataUrlToBlob(dataUrl) {
  const [head, b64 = ""] = dataUrl.split(",");
  const mime = /data:([^;]+)/.exec(head)?.[1] || "image/png";
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

function extFromMime(mime = "") {
  if (mime.includes("png")) return "png";
  if (mime.includes("webp")) return "webp";
  return "jpg";
}

// خروجی runTryOn می‌تواند رشته‌ی تصویر یا آبجکت { result|url, ... } باشد
function normalizeTryOnResult(out) {
  if (typeof out === "string") return { url: out, quota: null };
  const url = out?.result || out?.url || "";
  const hasQuota = out && (out.daily_limit != null || out.dailyLimit != null);
  return {
    url,
    quota: hasQuota
      ? {
          usedToday: Number(out.used_today ?? out.usedToday ?? 0),
          dailyLimit: Number(out.daily_limit ?? out.dailyLimit ?? 0),
        }
      : null,
  };
}

function TryOnDialog({ open, onClose, item, storeId }) {
  // info | otp | choose | camera | preview | loading | result
  const [step, setStep] = useState("info");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [photo, setPhoto] = useState(null); // { blob, url }
  const [resultUrl, setResultUrl] = useState("");
  const [error, setError] = useState("");
  const [cameraError, setCameraError] = useState("");
  const [cameraReady, setCameraReady] = useState(false);
  const [msgIndex, setMsgIndex] = useState(0);
  const [quota, setQuota] = useState(null);

  // کد تایید
  const [otpCode, setOtpCode] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpBusy, setOtpBusy] = useState(false);
  const [resendLeft, setResendLeft] = useState(0);
  const [verified, setVerified] = useState(null); // { phone, token }

  // دوربین
  const [facingMode, setFacingMode] = useState("user");
  const [canSwitchCamera, setCanSwitchCamera] = useState(false);
  const [timerSec, setTimerSec] = useState(0);
  const [countdown, setCountdown] = useState(null);
  const [showGrid, setShowGrid] = useState(false);
  const [torchOn, setTorchOn] = useState(false);
  const [torchSupported, setTorchSupported] = useState(false);
  const [zoomCaps, setZoomCaps] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [flash, setFlash] = useState(false);

  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const fileRef = useRef(null);
  const abortRef = useRef(null);
  const closeBtnRef = useRef(null);
  const photoUrlRef = useRef("");

  const setPhotoBlob = useCallback((blob) => {
    if (photoUrlRef.current) URL.revokeObjectURL(photoUrlRef.current);
    const url = URL.createObjectURL(blob);
    photoUrlRef.current = url;
    setPhoto({ blob, url });
  }, []);

  const clearPhoto = useCallback(() => {
    if (photoUrlRef.current) URL.revokeObjectURL(photoUrlRef.current);
    photoUrlRef.current = "";
    setPhoto(null);
  }, []);

  useEffect(
    () => () => {
      if (photoUrlRef.current) URL.revokeObjectURL(photoUrlRef.current);
    },
    [],
  );

  const close = useCallback(() => {
    abortRef.current?.abort();
    onClose();
    setStep("info");
    setResultUrl("");
    setError("");
    setFieldErrors({});
    setOtpCode("");
    setOtpError("");
    clearPhoto();
  }, [clearPhoto, onClose]);

  const cancelLoading = useCallback(() => {
    abortRef.current?.abort();
    setStep("preview");
  }, []);

  // اگر کاربر لباس را عوض کرد (بعد از بستن)، نتیجه‌ی قبلی پاک شود
  useEffect(() => {
    if (open) return;
    setResultUrl("");
  }, [open, item?.id]);

  // قفل اسکرول + فوکوس + Esc
  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeBtnRef.current?.focus();
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      if (step === "loading") cancelLoading();
      else close();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, step, close, cancelLoading]);

  // شمارنده‌ی ارسال مجدد کد
  useEffect(() => {
    if (resendLeft <= 0) return undefined;
    const t = setTimeout(() => setResendLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [resendLeft]);

  /* ---------- اطلاعات ---------- */
  const onNameChange = (e) => {
    setName(e.target.value);
    if (fieldErrors.name) setFieldErrors((f) => ({ ...f, name: "" }));
  };

  const onPhoneChange = (e) => {
    const v = normalizeDigits(e.target.value).replace(/\D/g, "").slice(0, 11);
    setPhone(v);
    if (fieldErrors.phone) setFieldErrors((f) => ({ ...f, phone: "" }));
  };

  const requestOtp = async (p) => {
    setOtpBusy(true);
    setOtpError("");
    try {
      console.log(p);
      await sendProMajaziOtp(p);
      setOtpCode("");
      setResendLeft(RESEND_SECONDS);
      setStep("otp");
    } catch (err) {
      if (step === "otp") {
        setOtpError(err?.message || "ارسال کد ناموفق بود.");
      } else {
        setFieldErrors({ phone: err?.message || "ارسال کد ناموفق بود." });
      }
    } finally {
      setOtpBusy(false);
    }
  };

  const submitInfo = (e) => {
    e.preventDefault();
    if (otpBusy) return;
    const n = name.trim();
    const p = normalizeDigits(phone).trim();
    const errs = {};
    if (n.length < 2) errs.name = "لطفاً نام خود را وارد کنید.";
    if (!PHONE_RE.test(p)) {
      errs.phone = "شماره‌ی موبایل معتبر نیست (مثال: ۰۹۱۲۳۴۵۶۷۸۹).";
    }
    setFieldErrors(errs);
    if (Object.keys(errs).length) return;
    setName(n);
    setPhone(p);
    // اگر همین شماره قبلاً تایید شده، دوباره کد نمی‌خواهد
    if (verified?.phone === p) {
      setStep("choose");
      return;
    }
    requestOtp(p);
  };

  /* ---------- کد تایید ---------- */
  const verifyOtp = async (code) => {
    if (otpBusy) return;
    setOtpBusy(true);
    setOtpError("");
    try {
      const out = await verifyProMajaziOtp({ storeId, phone, code });
      setVerified({ phone, token: out?.token || "" });
      setStep("choose");
    } catch (err) {
      setOtpError(err?.message || "کد واردشده اشتباه است.");
      setOtpCode("");
    } finally {
      setOtpBusy(false);
    }
  };

  const onOtpChange = (e) => {
    const v = normalizeDigits(e.target.value)
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);
    setOtpCode(v);
    if (otpError) setOtpError("");
    if (v.length === OTP_LENGTH) verifyOtp(v);
  };

  const resendOtp = () => {
    if (resendLeft > 0 || otpBusy) return;
    requestOtp(phone);
  };

  /* ---------- دوربین ---------- */
  useEffect(() => {
    if (!open || step !== "camera") return undefined;

    let cancelled = false;
    setCameraError("");
    setCameraReady(false);
    setTorchOn(false);
    setTorchSupported(false);
    setZoomCaps(null);
    setZoom(1);
    setCountdown(null);

    (async () => {
      if (!navigator.mediaDevices?.getUserMedia) {
        setCameraError(
          "این مرورگر از دوربین پشتیبانی نمی‌کند یا صفحه با HTTPS باز نشده است. می‌توانید عکس آپلود کنید.",
        );
        return;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: { ideal: facingMode },
            width: { ideal: 1280 },
            height: { ideal: 1280 },
          },
          audio: false,
        });
        if (cancelled) {
          stream.getTracks().forEach((t) => t.stop());
          return;
        }
        streamRef.current = stream;

        const track = stream.getVideoTracks()[0];
        const caps = track?.getCapabilities?.() || {};
        setTorchSupported(!!caps.torch);
        if (caps.zoom && caps.zoom.max > caps.zoom.min) {
          setZoomCaps({
            min: caps.zoom.min,
            max: caps.zoom.max,
            step: caps.zoom.step || 0.1,
          });
          setZoom(track.getSettings?.().zoom || caps.zoom.min);
        }

        navigator.mediaDevices
          .enumerateDevices?.()
          .then((list) => {
            if (cancelled) return;
            setCanSwitchCamera(
              list.filter((d) => d.kind === "videoinput").length > 1,
            );
          })
          .catch(() => {});

        const video = videoRef.current;
        if (video) {
          video.srcObject = stream;
          await video.play().catch(() => {});
          setCameraReady(true);
        }
      } catch (err) {
        if (cancelled) return;
        setCameraError(
          err?.name === "NotAllowedError"
            ? "دسترسی به دوربین داده نشد. از تنظیمات مرورگر اجازه بدهید یا عکس آپلود کنید."
            : "دوربینی پیدا نشد. می‌توانید عکس آپلود کنید.",
        );
      }
    })();

    return () => {
      cancelled = true;
      streamRef.current?.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
    };
  }, [open, step, facingMode]);

  const capture = useCallback(async () => {
    const video = videoRef.current;
    if (!video?.videoWidth) return;
    setFlash(true);
    setTimeout(() => setFlash(false), 180);
    try {
      // پیش‌نمایش دوربین جلو آینه‌ای است؛ عکس هم همان‌طور ذخیره می‌شود
      const canvas = drawScaled(
        video,
        video.videoWidth,
        video.videoHeight,
        facingMode === "user",
      );
      const blob = await canvasToJpeg(canvas);
      setPhotoBlob(blob);
      setError("");
      setStep("preview");
    } catch {
      setCameraError("گرفتن عکس ناموفق بود. دوباره تلاش کنید.");
    }
  }, [setPhotoBlob, facingMode]);

  const applyTrackConstraint = async (constraint) => {
    const track = streamRef.current?.getVideoTracks()[0];
    if (!track) return false;
    try {
      await track.applyConstraints({ advanced: [constraint] });
      return true;
    } catch {
      return false;
    }
  };

  const flipCamera = () => {
    setCountdown(null);
    setFacingMode((m) => (m === "user" ? "environment" : "user"));
  };

  const toggleTorch = async () => {
    const next = !torchOn;
    if (await applyTrackConstraint({ torch: next })) setTorchOn(next);
  };

  const onZoomChange = async (e) => {
    const v = Number(e.target.value);
    setZoom(v);
    await applyTrackConstraint({ zoom: v });
  };

  const cycleTimer = () => {
    const options = [0, 3, 5, 10];
    setTimerSec((t) => options[(options.indexOf(t) + 1) % options.length]);
  };

  const onShutter = () => {
    if (countdown != null) {
      setCountdown(null);
      return;
    }
    if (timerSec > 0) setCountdown(timerSec);
    else capture();
  };

  useEffect(() => {
    if (countdown == null) return undefined;
    if (countdown === 0) {
      setCountdown(null);
      capture();
      return undefined;
    }
    const t = setTimeout(
      () => setCountdown((c) => (c == null ? c : c - 1)),
      1000,
    );
    return () => clearTimeout(t);
  }, [countdown, capture]);

  /* ---------- آپلود ---------- */
  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setError("");
    if (!file.type.startsWith("image/")) {
      setError("لطفاً فقط فایل تصویری انتخاب کنید.");
      return;
    }
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      setError(
        `حجم عکس باید کمتر از ${MAX_FILE_MB.toLocaleString("fa-IR")} مگابایت باشد.`,
      );
      return;
    }
    try {
      const blob = await fileToJpegBlob(file);
      setPhotoBlob(blob);
      setStep("preview");
    } catch {
      setError("این فرمت عکس پشتیبانی نمی‌شود. لطفاً JPG یا PNG انتخاب کنید.");
    }
  };

  /* ---------- ارسال و دریافت نتیجه ---------- */
  const submit = async () => {
    if (!photo || !item) return;
    setError("");
    setStep("loading");
    const controller = new AbortController();
    abortRef.current = controller;
    try {
      const out = await runWebsiteTryOn({
        storeId,
        productId: item.id,
        image: photo.blob,
        colorId: null,
        // آدرس کامل عکس لباس (برای localhost سرور نمی‌تواند باز کند)
        productImageUrl: item.front
          ? new URL(item.front, window.location.origin).href
          : "",
        customerName: name,
        customerPhone: phone,
        otpToken: verified?.token || "",
        signal: controller.signal,
      });
      const { url, quota: q } = normalizeTryOnResult(out);
      if (!url) throw new Error("تصویری از سرور دریافت نشد. دوباره تلاش کنید.");
      setResultUrl(url);
      if (q) setQuota(q);
      setStep("result");
    } catch (err) {
      if (err?.name === "AbortError") return;
      setError(err?.message || "مشکلی پیش آمد. دوباره تلاش کنید.");
      setStep("preview");
    }
  };

  useEffect(() => {
    if (step !== "loading") return undefined;
    setMsgIndex(0);
    const t = setInterval(
      () => setMsgIndex((i) => Math.min(i + 1, LOADING_MESSAGES.length - 1)),
      3500,
    );
    return () => clearInterval(t);
  }, [step]);

  const download = async () => {
    try {
      const blob = resultUrl.startsWith("data:")
        ? dataUrlToBlob(resultUrl)
        : await (await fetch(resultUrl)).blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `pro-online.${extFromMime(blob.type)}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    } catch {
      if (!resultUrl.startsWith("data:")) {
        window.open(resultUrl, "_blank", "noopener");
      } else {
        setError("دانلود تصویر ناموفق بود. دوباره تلاش کنید.");
      }
    }
  };

  // شروع دوباره با عکس جدید (نام، موبایل و تایید OTP حفظ می‌شود)
  const startOver = () => {
    clearPhoto();
    setResultUrl("");
    setError("");
    setStep("choose");
  };

  const limitReached =
    !!quota && quota.dailyLimit > 0 && quota.usedToday >= quota.dailyLimit;

  if (!open) return null;

  return createPortal(
    <div className="vto-overlay" onClick={() => step !== "loading" && close()}>
      <div
        className="vto-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="vto-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="vto-head">
          <div className="vto-head-text">
            <h2 id="vto-title">پرو آنلاین</h2>
            {item?.name && <p>{item.name}</p>}
          </div>
          <button
            ref={closeBtnRef}
            type="button"
            className="vto-icon-btn"
            onClick={close}
            aria-label="بستن"
          >
            <IcClose size={18} />
          </button>
        </header>

        <div className="vto-body">
          {/* ---------- نام و موبایل ---------- */}
          {step === "info" && (
            <form className="vto-form" onSubmit={submitInfo} noValidate>
              <p className="vto-lead">
                قبل از شروع، نام و شماره‌ی موبایل خود را وارد کنید.
              </p>

              <div className="vto-field">
                <label htmlFor="vto-name">نام و نام خانوادگی</label>
                <input
                  id="vto-name"
                  type="text"
                  className={`vto-input ${fieldErrors.name ? "is-invalid" : ""}`}
                  value={name}
                  onChange={onNameChange}
                  autoComplete="name"
                  autoFocus
                  maxLength={60}
                  aria-invalid={!!fieldErrors.name}
                />
                {fieldErrors.name && (
                  <span className="vto-field-error" role="alert">
                    {fieldErrors.name}
                  </span>
                )}
              </div>

              <div className="vto-field">
                <label htmlFor="vto-phone">شماره‌ی موبایل</label>
                <input
                  id="vto-phone"
                  type="tel"
                  inputMode="numeric"
                  dir="ltr"
                  placeholder="09123456789"
                  className={`vto-input vto-input--ltr ${fieldErrors.phone ? "is-invalid" : ""}`}
                  value={phone}
                  onChange={onPhoneChange}
                  autoComplete="tel"
                  aria-invalid={!!fieldErrors.phone}
                />
                {fieldErrors.phone && (
                  <span className="vto-field-error" role="alert">
                    {fieldErrors.phone}
                  </span>
                )}
              </div>

              <div className="vto-actions">
                <button
                  type="submit"
                  className="vto-btn vto-btn--primary vto-btn--grow"
                  disabled={otpBusy}
                >
                  {otpBusy ? "در حال ارسال کد…" : "ادامه"}
                </button>
              </div>
            </form>
          )}

          {/* ---------- کد تایید ---------- */}
          {step === "otp" && (
            <div className="vto-form">
              <p className="vto-lead">
                کد {OTP_LENGTH.toLocaleString("fa-IR")} رقمی به شماره‌ی{" "}
                <b dir="ltr" className="vto-otp-phone">
                  {phone}
                </b>{" "}
                پیامک شد.
              </p>

              <div className="vto-field">
                <label htmlFor="vto-otp">کد تایید</label>
                <input
                  id="vto-otp"
                  type="text"
                  inputMode="numeric"
                  dir="ltr"
                  autoComplete="one-time-code"
                  autoFocus
                  placeholder={"•".repeat(OTP_LENGTH)}
                  className={`vto-input vto-input--ltr vto-input--otp ${otpError ? "is-invalid" : ""}`}
                  value={otpCode}
                  onChange={onOtpChange}
                  disabled={otpBusy}
                  aria-invalid={!!otpError}
                />
                {otpError && (
                  <span className="vto-field-error" role="alert">
                    {otpError}
                  </span>
                )}
              </div>

              <div className="vto-actions">
                <button
                  type="button"
                  className="vto-btn vto-btn--primary vto-btn--grow"
                  onClick={() => verifyOtp(otpCode)}
                  disabled={otpBusy || otpCode.length !== OTP_LENGTH}
                >
                  {otpBusy ? "در حال بررسی…" : "تایید و ادامه"}
                </button>
              </div>

              <div className="vto-otp-links">
                <button
                  type="button"
                  className="vto-link"
                  onClick={resendOtp}
                  disabled={resendLeft > 0 || otpBusy}
                >
                  {resendLeft > 0
                    ? `ارسال مجدد کد (${resendLeft.toLocaleString("fa-IR")} ثانیه)`
                    : "ارسال مجدد کد"}
                </button>
                <button
                  type="button"
                  className="vto-link"
                  onClick={() => {
                    setOtpError("");
                    setStep("info");
                  }}
                >
                  ویرایش شماره
                </button>
              </div>
            </div>
          )}

          {/* ---------- انتخاب روش ---------- */}
          {step === "choose" && (
            <>
              <p className="vto-lead">
                با عکس خودتان ببینید این لباس چه شکلی روی شما می‌نشیند.
              </p>

              <ul className="vto-tips">
                <li>عکس واضح و با نور کافی بگیرید.</li>
                <li>رو به دوربین و بدون فیلتر باشید.</li>
                <li>بدن شما تا جای ممکن در کادر باشد.</li>
              </ul>

              {error && (
                <div className="vto-alert" role="alert">
                  {error}
                </div>
              )}

              <div className="vto-options">
                <button
                  type="button"
                  className="vto-option"
                  onClick={() => {
                    setError("");
                    setStep("camera");
                  }}
                >
                  <span className="vto-option-icon">
                    <IcCamera size={24} />
                  </span>
                  گرفتن عکس
                </button>
                <button
                  type="button"
                  className="vto-option"
                  onClick={() => fileRef.current?.click()}
                >
                  <span className="vto-option-icon">
                    <IcUpload size={24} />
                  </span>
                  آپلود عکس
                </button>
              </div>

              <div className="vto-actions">
                <button
                  type="button"
                  className="vto-btn vto-btn--ghost vto-btn--grow"
                  onClick={() => setStep("info")}
                >
                  ویرایش نام و شماره
                </button>
              </div>

              <input
                ref={fileRef}
                type="file"
                accept="image/*"
                hidden
                onChange={onFile}
              />
            </>
          )}

          {/* ---------- دوربین ---------- */}
          {step === "camera" && (
            <>
              <div className="vto-stage">
                {cameraError ? (
                  <div className="vto-stage-msg">{cameraError}</div>
                ) : (
                  <>
                    <video
                      ref={videoRef}
                      className={`vto-video ${facingMode === "user" ? "vto-video--mirror" : ""}`}
                      autoPlay
                      playsInline
                      muted
                    />
                    {showGrid && cameraReady && (
                      <div className="vto-grid" aria-hidden="true" />
                    )}
                    {countdown != null && countdown > 0 && (
                      <div className="vto-countdown" aria-live="assertive">
                        {countdown.toLocaleString("fa-IR")}
                      </div>
                    )}
                    {flash && <div className="vto-flash" aria-hidden="true" />}
                    {!cameraReady && (
                      <div className="vto-stage-msg">
                        در حال روشن شدن دوربین…
                      </div>
                    )}
                    {cameraReady && (
                      <div className="vto-cam-tools">
                        {canSwitchCamera && (
                          <button
                            type="button"
                            className="vto-tool"
                            onClick={flipCamera}
                            aria-label="تغییر دوربین"
                          >
                            <IcFlip size={20} />
                          </button>
                        )}
                        {torchSupported && (
                          <button
                            type="button"
                            className={`vto-tool ${torchOn ? "is-active" : ""}`}
                            onClick={toggleTorch}
                            aria-pressed={torchOn}
                            aria-label="فلش"
                          >
                            <IcFlash size={20} />
                          </button>
                        )}
                        <button
                          type="button"
                          className={`vto-tool ${timerSec ? "is-active" : ""}`}
                          onClick={cycleTimer}
                          aria-label="تایمر عکس"
                        >
                          <IcTimer size={20} />
                          {timerSec > 0 && (
                            <span className="vto-tool-badge">
                              {timerSec.toLocaleString("fa-IR")}
                            </span>
                          )}
                        </button>
                        <button
                          type="button"
                          className={`vto-tool ${showGrid ? "is-active" : ""}`}
                          onClick={() => setShowGrid((g) => !g)}
                          aria-pressed={showGrid}
                          aria-label="خطوط راهنما"
                        >
                          <IcGrid size={20} />
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>

              {zoomCaps && cameraReady && !cameraError && (
                <div className="vto-zoom">
                  <span>زوم</span>
                  <input
                    type="range"
                    min={zoomCaps.min}
                    max={zoomCaps.max}
                    step={zoomCaps.step}
                    value={zoom}
                    onChange={onZoomChange}
                    aria-label="زوم دوربین"
                  />
                </div>
              )}

              <div className="vto-actions vto-actions--between">
                <button
                  type="button"
                  className="vto-btn vto-btn--ghost"
                  onClick={() => setStep("choose")}
                >
                  بازگشت
                </button>

                {cameraError ? (
                  <button
                    type="button"
                    className="vto-btn vto-btn--primary"
                    onClick={() => {
                      setStep("choose");
                      setTimeout(() => fileRef.current?.click(), 0);
                    }}
                  >
                    <IcUpload size={18} />
                    آپلود عکس
                  </button>
                ) : (
                  <button
                    type="button"
                    className="vto-shutter"
                    onClick={onShutter}
                    disabled={!cameraReady}
                    aria-label={countdown != null ? "لغو تایمر" : "گرفتن عکس"}
                  />
                )}

                <span className="vto-actions-spacer" aria-hidden="true" />
              </div>
            </>
          )}

          {/* ---------- پیش‌نمایش عکس ---------- */}
          {step === "preview" && photo && (
            <>
              <div className="vto-stage">
                <img className="vto-img" src={photo.url} alt="عکس شما" />
              </div>

              {error && (
                <div className="vto-alert" role="alert">
                  {error}
                </div>
              )}
              {limitReached && (
                <div className="vto-alert" role="alert">
                  سهمیه‌ی امروز شما تمام شده است. فردا دوباره امتحان کنید.
                </div>
              )}

              <div className="vto-actions">
                <button
                  type="button"
                  className="vto-btn vto-btn--primary vto-btn--grow"
                  onClick={submit}
                  disabled={limitReached}
                >
                  <IcSparkle size={18} />
                  {error ? "تلاش دوباره" : "ساخت تصویر پرو"}
                </button>
                <button
                  type="button"
                  className="vto-btn vto-btn--ghost"
                  onClick={startOver}
                >
                  عکس دیگر
                </button>
              </div>
            </>
          )}

          {/* ---------- لودر ---------- */}
          {step === "loading" && photo && (
            <>
              <div className="vto-stage" aria-busy="true">
                <img className="vto-img vto-img--dim" src={photo.url} alt="" />
                <div className="vto-scan" />
                <div className="vto-loader">
                  <span className="vto-spinner" />
                  <span aria-live="polite">{LOADING_MESSAGES[msgIndex]}</span>
                </div>
              </div>
              <div className="vto-actions">
                <button
                  type="button"
                  className="vto-btn vto-btn--ghost vto-btn--grow"
                  onClick={cancelLoading}
                >
                  لغو
                </button>
              </div>
            </>
          )}

          {/* ---------- نتیجه ---------- */}
          {step === "result" && resultUrl && (
            <>
              <div className="vto-stage">
                <img
                  className="vto-img vto-img--result"
                  src={resultUrl}
                  alt="نتیجه‌ی پرو آنلاین"
                  onError={() => {
                    setError("نمایش تصویر نتیجه ناموفق بود. دوباره تلاش کنید.");
                    setStep("preview");
                  }}
                />
              </div>

              <p className="vto-note">
                این تصویر یک شبیه‌سازی است و ممکن است با لباس واقعی کمی تفاوت
                داشته باشد.
              </p>

              {quota && quota.dailyLimit > 0 && (
                <p className="vto-note">
                  امروز {quota.usedToday.toLocaleString("fa-IR")} از{" "}
                  {quota.dailyLimit.toLocaleString("fa-IR")} بار استفاده
                  کرده‌اید.
                </p>
              )}

              {error && (
                <div className="vto-alert" role="alert">
                  {error}
                </div>
              )}

              <div className="vto-actions">
                <button
                  type="button"
                  className="vto-btn vto-btn--primary vto-btn--grow"
                  onClick={download}
                >
                  <IcDownload size={18} />
                  دانلود تصویر
                </button>
                <button
                  type="button"
                  className="vto-btn vto-btn--ghost"
                  onClick={startOver}
                >
                  <IcRefresh size={18} />
                  امتحان دوباره
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
}

/* ---------- صفحه ---------- */
export default function FittingRoom() {
  const items = ITEMS;
  const [cur, setCur] = useState(0);
  const [open, setOpen] = useState(false);
  const [dir, setDir] = useState(0);
  const rackRef = useRef(null);
  const pageRef = useRef(null);
  const [tryOnOpen, setTryOnOpen] = useState(false);
  const [sceneTop, setSceneTop] = useState(null); // فاصله‌ی بالای صحنه تا بالای صفحه (هدر)
  const [hangerRatio, setHangerRatio] = useState(null); // ارتفاع ÷ عرض چوب‌لباسی
  const [footerH, setFooterH] = useState(0); // ارتفاع فوتر سایت
  const [center, setCenter] = useState(-1); // موبایل: اندیس لباسِ وسط صفحه (-1 = دسکتاپ)
  const [footerBg, setFooterBg] = useState(""); // رنگ پس‌زمینه‌ی فوتر

  // عکس از بالای صفحه (پشت هدر) شروع می‌شود؛ ارتفاع هدر را اندازه می‌گیریم تا عکس را همان‌قدر بالا بکشیم
  useEffect(() => {
    const measure = () => {
      const el = pageRef.current;
      if (!el) return;
      setSceneTop(Math.round(el.getBoundingClientRect().top + window.scrollY));
    };
    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);
    return () => {
      window.removeEventListener("resize", measure);
      window.removeEventListener("load", measure);
    };
  }, []);

  // هدر سایت باید روی عکس بماند (عکس از بالای صفحه و پشت هدر شروع می‌شود)
  useEffect(() => {
    const page = pageRef.current;
    if (!page || sceneTop == null) return;
    const cands = new Set([
      document.querySelector("header"),
      page.previousElementSibling,
      page.parentElement && page.parentElement.previousElementSibling,
    ]);
    const undo = [];
    cands.forEach((el) => {
      if (!el || el === page || el.contains(page)) return;
      const r = el.getBoundingClientRect();
      const top = r.top + window.scrollY;
      if (top > sceneTop || top + r.height > sceneTop + 4) return; // فقط چیزهایی که بالای صفحه‌اند
      const cs = getComputedStyle(el);
      const prev = { p: el.style.position, z: el.style.zIndex };
      if (cs.position === "static") el.style.position = "relative";
      const z = parseInt(cs.zIndex, 10);
      if (Number.isNaN(z) || z < 10) el.style.zIndex = "10";
      undo.push(() => {
        el.style.position = prev.p;
        el.style.zIndex = prev.z;
      });
    });
    return () => undo.forEach((f) => f());
  }, [sceneTop]);

  // پس‌زمینه باید پشت فوتر هم ادامه پیدا کند؛ فوتر روی عکس می‌ماند
  useEffect(() => {
    const page = pageRef.current;
    if (!page) return;
    const footer =
      document.querySelector("footer") ||
      (page.parentElement && page.parentElement.nextElementSibling);
    if (!footer || page.contains(footer)) return;

    const prev = { p: footer.style.position, z: footer.style.zIndex };
    const cs = getComputedStyle(footer);
    if (cs.position === "static") footer.style.position = "relative";
    const z = parseInt(cs.zIndex, 10);
    if (Number.isNaN(z) || z < 10) footer.style.zIndex = "10";

    const measure = () => {
      setFooterH(Math.round(footer.getBoundingClientRect().height));
      const bg = getComputedStyle(footer).backgroundColor;
      if (bg && bg !== "rgba(0, 0, 0, 0)" && bg !== "transparent")
        setFooterBg(bg);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(footer);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
      footer.style.position = prev.p;
      footer.style.zIndex = prev.z;
    };
  }, []);

  // نوک قلاب چوب‌لباسی باید دقیق روی میله بنشیند؛ برای همین نسبت عکس چوب‌لباسی را می‌خوانیم
  useEffect(() => {
    if (!hangerImage) return;
    const im = new Image();
    im.onload = () => setHangerRatio(im.naturalHeight / im.naturalWidth);
    im.src = hangerImage;
  }, []);

  const sceneStyle = {
    "--fr-top": sceneTop != null ? sceneTop + "px" : undefined,
    "--fr-bottom": footerH + "px",
    "--hr": hangerImage ? (hangerRatio ?? 0.55) : 0,
    "--fr-footer-bg": footerBg || undefined,
    "--fr-mobile-bg": mobileSceneImage
      ? `url("${mobileSceneImage}")`
      : undefined,
  };

  // روی موبایل عکس عریض‌تر از صفحه است؛ از وسط شروع کن
  useEffect(() => {
    const el = rackRef.current;
    if (!el) return;
    const max = el.scrollWidth - el.clientWidth;
    const rtl = getComputedStyle(el).direction === "rtl";
    el.scrollLeft = ((rtl ? -1 : 1) * max) / 2;
  }, []);

  // موبایل: لباسِ نزدیک به وسط صفحه «فعال» می‌شود (مثل هاور در دسکتاپ)
  useEffect(() => {
    const rack = rackRef.current;
    if (!rack) return;
    const mq = window.matchMedia("(max-width: 720px)");
    let raf = 0;
    const calc = () => {
      if (!mq.matches) {
        setCenter(-1);
        return;
      }
      const scene = rack.querySelector(".fr-scene");
      const canvas = rack.querySelector(".fr-canvas");
      const hang = rack.querySelector(".fr-hang");
      if (!scene || !canvas || !hang) return;
      // مرکز صفحه در مختصات صحنه (از offsetLeft استفاده می‌کنیم تا تحت تأثیر transform نباشد)
      const mid =
        rack.clientWidth / 2 -
        (scene.getBoundingClientRect().left -
          rack.getBoundingClientRect().left);
      let best = 0,
        bd = Infinity;
      rack.querySelectorAll(".fr-item").forEach((n, i) => {
        const x =
          canvas.offsetLeft +
          hang.offsetLeft +
          n.offsetLeft +
          n.offsetWidth / 2;
        const d = Math.abs(x - mid);
        if (d < bd) {
          bd = d;
          best = i;
        }
      });
      setCenter(best);
    };
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(calc);
    };
    rack.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    calc();
    return () => {
      cancelAnimationFrame(raf);
      rack.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  useEffect(() => {
    document.title = CONFIG.brandName + " | اتاق پرو";
  }, []);

  const openModal = useCallback((i) => {
    setCur(i);
    setDir(0);
    setOpen(true);
  }, []);
  const closeModal = useCallback(() => setOpen(false), []);
  const go = useCallback(
    (step) => {
      if (items.length < 2) return;
      setCur((c) => (c + step + items.length) % items.length);
      setDir(-step);
    },
    [items.length],
  );

  // کلیک روی «پرو آنلاین» → نام و موبایل ← کد تایید ← گرفتن یا آپلود عکس ← پرو
  const startTryOn = useCallback(() => setTryOnOpen(true), []);
  const closeTryOn = useCallback(() => setTryOnOpen(false), []);

  const current = items[cur];

  return (
    <Layout>
      <section className="fr-page" dir="rtl" lang="fa" ref={pageRef}>
        <div
          className={"fr-rack-wrap" + (mobileSceneImage ? " fr-has-mbg" : "")}
          style={sceneStyle}
        >
          <div className="fr-rack" ref={rackRef}>
            {/* عکس رگال پس‌زمینه است؛ لباس‌ها با قلاب روی میله‌ی بالاییِ همان عکس آویزان می‌شوند */}
            <div className="fr-scene">
              <div className="fr-canvas">
                {sceneImage && (
                  <img
                    className="fr-scene-bg"
                    src={sceneImage}
                    alt=""
                    draggable={false}
                  />
                )}
                {/* ادامه‌ی پایین عکس پشت فوتر */}
                {sceneImage && (
                  <div
                    className="fr-ext"
                    aria-hidden="true"
                    style={{ backgroundImage: `url(${sceneImage})` }}
                  />
                )}
                <div
                  className="fr-hang"
                  style={{
                    "--ov-fit": `calc(${ITEM_W - STEP} * var(--px))`,
                    "--gap-w": `calc(${GAP_W} * var(--px))`,
                  }}
                >
                  {items.map((it, i) => (
                    <RackItem
                      key={i}
                      item={it}
                      index={i}
                      onOpen={openModal}
                      hr={hangerRatio ?? 0.55}
                      state={
                        center < 0
                          ? undefined
                          : i === center
                            ? "active"
                            : i < center
                              ? "before"
                              : "after"
                      }
                    />
                  ))}
                </div>
                {/* دکور روی طبقه‌ی سفید عکس (عکس‌ها از DECOR) */}
                <div className="fr-shelf" aria-hidden="true">
                  {DECOR.filter((d) => d.src).map((d, i) => (
                    <span
                      key={"d" + i}
                      className={
                        "fr-deco" + (d.className ? " " + d.className : "")
                      }
                      style={{
                        "--x": /px$/.test(String(d.x))
                          ? `calc(${parseFloat(d.x)} * var(--px))`
                          : d.x,
                        "--w":
                          d.w != null ? `calc(${d.w} * var(--px))` : undefined,
                        "--y": `calc(${Number(d.y || 0)} * var(--px))`,
                        "--r": (d.r ?? -4) + "deg",
                        "--flip": d.flip ? -1 : 1,
                        "--z": d.z ?? 2,
                        ...d.style,
                      }}
                    >
                      <img src={d.src} alt="" draggable={false} />
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        items={items}
        cur={cur}
        open={open}
        dir={dir}
        onClose={closeModal}
        onGo={go}
        onTryOn={startTryOn}
      />

      <TryOnDialog
        open={tryOnOpen}
        onClose={closeTryOn}
        item={current}
        storeId={CONFIG.storeId}
      />
    </Layout>
  );
}
